import { all, call, delay, put, race, take } from 'redux-saga/effects';
import { initializationSuccess, initializationFailure } from 'actions/appActions';
import { tryLoginSaga } from '../shell/loginSaga';
import { loginSuccess } from 'actions/shellActions';
import { join } from 'api';

const _window = window;

const emptyCredentials = {
    username: '',
    password: '',
};

export function* initializationSuccessSaga(window: Window = _window) {
    const [ responseOrError ] = yield all([
        call(tryJoinOrLoginSaga, window.location),
        take('SET_LANGUAGE_SUCCESS'),
        take('SET_TIMELINE_LABEL_WIDTH'),
        take('SERVERDETAILS_SUCCESS'),
        // TODO: other initialization step successes
        delay(600), // Take at least 600ms to load so the loading screen doesn't flash too quickly
    ]);

    // If login was successful then fire of a LOGIN_SUCCESS action to trigger post-login tasks
    // It's safe to ignore login errors here. The user will have to log in manually.
    if (typeof responseOrError.stack !== 'string') {
        yield put(loginSuccess(responseOrError));
    }
}

export function* initializationFailureSaga() {
    const result = yield race({
        language: take('LANGUAGE_LOAD_FAILURE'),
        serverDetails: take('SERVERDETAILS_FAILURE'),
        // TODO: other initialization step failures
    });

    // Return the failing action
    const failKey = Object.keys(result).filter(key => !!result[key]).shift() as string;
    return result[failKey];
}

export function* tryJoinOrLoginSaga(location: Location) {
    // Check if the URL contains the `hasSessionToken` query parameter
    const hasSessionToken = new URLSearchParams(location.search).get('hasSessionToken');

    if (hasSessionToken === '1') {
        try {
            return yield call(join);
        } catch (err) {
            // Return instead of throwing to prevent breaking the 'all()' effect
            return err;
        }
    }

    // Test to see if we already have a valid session cookie (e.g. user hit F5)
    return yield call(tryLoginSaga, emptyCredentials);
}

export function* initSaga(window: Window = _window) {
    // Test browser dependency. No Internet Explorer.
    if (/MSIE|Trident/gi.test(navigator.userAgent)) {
        const error = new Error('Internet Explorer is not supported');
        yield put(initializationFailure(error));
        return;
    }
  
    const { failure } = yield race({
        success: call(initializationSuccessSaga),
        failure: call(initializationFailureSaga),
    });

    if (failure) {
        yield call(window.console.error, 'Failed to initialize', failure);
        yield put(initializationFailure(failure.payload));
        return;
    }

    yield put(initializationSuccess());
}



// WEBPACK FOOTER //
// ./src/sagas/app/initSaga.ts